import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';

import { Spine } from '../../../core/classes/spine';

function GameLogo({ containerConfig }) {
  const gameLogoContainerRef = useRef(null);

  useEffect(() => {
    const gameLogo = new Spine({ key: 'gameLogo' });
    gameLogo.play('animation', true);
    gameLogoContainerRef.current.addChild(gameLogo);
  }, [gameLogoContainerRef]);

  return <Container ref={gameLogoContainerRef} {...containerConfig} name='GameLogoContainer' />;
}

export default GameLogo;
